export default __webpack_public_path__ + "static/media/folderAdd.c1e61edf.svg";